$(document).on('focusin', function (e) {
    if ($(e.target).closest(".mce-window").length) {
        e.stopImmediatePropagation();
    }
});

function cOptionsSiteText() {
    var self = this;
    $(function () { self.onload(); });


}

cOptionsSiteText.prototype.onload = function () {
    var self = this;

    var elAddSiteTextOptionSubmitBtn = $('#add-site-text-option-submit-btn');
    var elEditSiteTextOptionSubmitBtn = $('#edit-site-text-option-submit-btn')
    var elSiteTextTable = $('#site-text-table');

    this.elAddSiteTextForm = $('#site-text-add-form');
    this.elEditSiteTextForm = $('#site-text-edit-form');

    $(elAddSiteTextOptionSubmitBtn).click(function (e) { return self.onAddSiteTextOptionSubmitBtnClick(this, e) });
    $(elEditSiteTextOptionSubmitBtn).click(function (e) { return self.onEditSiteTextOptionSubmitBtnClick(this, e) });

    // $(elSiteTextTable).dataTable({
    // 	'paging':   true,  //Table pagination
    // 	'ordering': true,  //Column ordering
    // 	'info':     true,  //Bottom left status text
    // 	//Text translation options
    // 	//Note the required keywords between underscores (e.g _MENU_)
    // 	oLanguage: {
    // 	    	sSearch:      'Search all columns:',
    // 	    	sLengthMenu:  '_MENU_ Site Text per page',
    // 	    	info:         'Showing page _PAGE_ of _PAGES_',
    // 	    	zeroRecords:  'Nothing found - sorry',
    // 	    	infoEmpty:    'No records available',
    // 	    	infoFiltered: '(filtered from _MAX_ total records)'
    // 		}
    // });
}

cOptionsSiteText.prototype.onAddSiteTextOptionSubmitBtnClick = function (btn, e) {
    if (!$(this.elAddSiteTextForm).find('*[name="key"]').val()) {
        return notify.error("Please specify a key for the site text");
    } if (!$(this.elAddSiteTextForm).find('*[name="value"]').val()) {
        //return notify.error("Please specify a value for the site text");
    }

    $(btn).button('loading');

    $(this.elAddSiteTextForm).ajaxSubmit({
        url: URL_ADMIN + '/options/main/addtext/',
        type: 'post',
        dataType: 'json',
        success: function (response, statusText, xhr, el) {
            if (response.success) {
                notify.success(response.message);
                setTimeout(function () {
                    window.location.reload();
                }, 2000);
            } else {
                notify.error(response.errors[0]);
                $(btn).button('reset');
            }
        },
        error: function (jqXHR) {
            return ajaxErrorCallback(jqXHR, btn);
        },
    });
    return;
}

cOptionsSiteText.prototype.onEditSiteTextOptionSubmitBtnClick = function (btn, e) {
    // if (!$(this.elEditSiteTextForm).find('*[name="key"]').val()) {
    // 	return notify.error("Please specify a key for the site text");
    // } if (!$(this.elEditSiteTextForm).find('*[name="value"]').val()) {
    // 	//return notify.error("Please specify a value for the site text");
    // }

    $(btn).button('loading');

    newtext = tinymce.activeEditor.getContent();

    $(this.elEditSiteTextForm).ajaxSubmit({
        url: URL_ADMIN + '/options/main/updatetext/',
        type: 'post',
        dataType: 'json',
        data: { 'value': newtext },
        success: function (response, statusText, xhr, el) {
            if (response.success) {
                notify.success(response.message);
                setTimeout(function () {
                    window.location.reload();
                }, 2000);
            } else {
                notify.error(response.errors[0]);
                $(btn).button('reset');
            }
        },
        error: function (jqXHR) {
            return ajaxErrorCallback(jqXHR, btn);
        },
    });
    return;
}

cOptionsSiteText.prototype.delete = function (site_text_id) {
    if (confirm('Delete this site text?')) {
        $(this.elAddSiteTextForm).ajaxSubmit({
            url: URL_ADMIN + '/options/main/deletetext/',
            type: 'post',
            dataType: 'json',
            data: {
                site_text_id: site_text_id
            },
            success: function (response, statusText, xhr, el) {
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                } else {
                    notify.error(response.errors[0]);
                    $(btn).button('reset');
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
    }
}

cOptionsSiteText.prototype.edit = function (row) {

    tinymce.remove();
    $('#edit-site-text-modal').find('#edit-id').val($(row).data('id'));
    $('#edit-site-text-modal').find('#edit-key').val($(row).data('key'));
    $('#edit-site-text-modal').find('#edit-key-span').text($(row).data('key'));
    $('#edit-site-text-modal').find('textarea#edit-value').val($(row).data('value'));
    $('#edit-site-text-modal').modal('show');
    tinymce.init({
        selector: '#edit-value',
        plugins: 'link media image',
        toolbar: 'styleselect | formatselect fontsizeselect | pastetext bold italic underline bullist numlist | aligncenter alignright alignnone link'
    });

}
